import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f075aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Units Grid View", -1))
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  style: {"margin-bottom":"25px"}
}
const _hoisted_6 = {
  key: 0,
  class: "row horizontal-start"
}
const _hoisted_7 = ["onMouseover"]
const _hoisted_8 = {
  key: 1,
  class: "detail"
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Unit", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Customer", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Phone:", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = {
  key: 1,
  class: "container"
}
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div data-v-6f075aac></div><div class=\"container\" data-v-6f075aac><h2 data-v-6f075aac>Legend</h2><div class=\"row legend\" data-v-6f075aac><div class=\"delinquent\" data-v-6f075aac>Delinquent</div><div class=\"auction\" data-v-6f075aac>Auction</div><div class=\"available\" data-v-6f075aac>Available</div><div class=\"late\" data-v-6f075aac>Late</div><div class=\"lien\" data-v-6f075aac>Lien</div><div class=\"locked_out\" data-v-6f075aac>Locked Out</div><div class=\"moving_out\" data-v-6f075aac>Moving Out</div><div class=\"pending\" data-v-6f075aac>Pending</div><div class=\"pre_lien\" data-v-6f075aac>Pre-Lien</div><div class=\"rented\" data-v-6f075aac>Rented</div><div class=\"reserved\" data-v-6f075aac>Reserved</div><div class=\"unavailable\" data-v-6f075aac>Unavailable</div></div></div>", 2)
const _hoisted_21 = { key: 0 }

import { ref } from "vue";
import { get } from "../../../src/methods/api";
import api from "@virgodev/bazaar/functions/api";
import { UnitInterface, UnitTypeInterface } from "@/types/unit";
import BaseSpinner from "@/components/BaseSpinner.vue";
import { CustomerDataInterface } from "@/types/customers";
import { storeToRefs } from "pinia";
import { useStore } from "../../store";

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const customers = ref(Array<CustomerDataInterface>());
const units = ref(Array<UnitInterface>());
// Statuses that already explain why a unit isn't rentable and that the grid has
// a colour and a legend entry for. Anything else — including "available" on a
// unit that isn't actually rentable — still falls back to "unavailable".
const UNRENTABLE_STATUSES = [
  "auction",
  "delinquent",
  "disabled",
  "late",
  "leased",
  "lien",
  "locked_out",
  "moving_out",
  "occupied",
  "offline",
  "overlock",
  "overlocked",
  "pending",
  "pre_lien",
  "rented",
  "reserved",
  "unavailable",
];

function isUnrentableStatus(value: string | null | undefined) {
  return !!value && UNRENTABLE_STATUSES.includes(value.toLowerCase());
}

const status = ref("loading");

const unitTypes = ref(Array<UnitTypeInterface>());
const newUnitTypes = ref(Array<UnitTypeInterface>());

const errors = ref("");
const ledgers = ref();

const hover = ref("-1");
// const rentals = ref();
function hoverUnit(id: string) {
  hover.value = id;
}

function uniqueBy<T>(items: T[], getKey: (item: T) => string) {
  const seen = new Set<string>();
  return items.filter((item: T) => {
    const key = getKey(item);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
}

async function getCustomers() {
  errors.value = "";
  let url = `customers/?facilityId=${props.facilityId}&id_customer=all_customers&include=meta`;
  let response = await get(url);
  if (response) {
    if (response.tenants) {
      if (response.meta.pagination) {
        let responseData = await get(
          (url += "&per_page=" + response.meta.pagination.total_entries)
        );
        customers.value = responseData.tenants;
      } else {
        customers.value = response.tenants;
      }
    } else {
      customers.value = response;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getAllUnitGroups() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    newUnitTypes.value = [];
    unitTypes.value = uniqueBy(response.body, (unitType: UnitTypeInterface) =>
      [unitType.id, unitType.size, unitType.description].join("-")
    );

    for (let unitType of unitTypes.value) {
      if (api_settings.sort_units_by_size) {
        if (!unitType.size) {
          let unitsizes = Array<string>();
          let filteredUnits = units.value.filter(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            (item: UnitInterface) => item.unit_group_id == unitType.id
          );
          for (let unit of filteredUnits) {
            if (!unitsizes.includes(unit.size)) {
              unitsizes.push(unit.size);
            }
          }
          for (let size of unitsizes) {
            let filteredUnitsFromList = units.value.filter(
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              (item: UnitInterface) =>
                item.unit_group_id.toString() == unitType.id &&
                item.size == size
            );
            newUnitTypes.value.push({
              additional_deposit: null,
              additional_deposit_name: null,
              allow_tenant_protection: false,
              available: true,
              available_unit_count: unitType.available_units_count,
              created_at: null,
              deposit: null,
              description: unitType.description,
              height: 0,
              id: "",
              length: 0,
              name: null,
              price: null,
              rent_tax_rate_id: 0,
              reservation_price: null,
              setup_fee: null,
              setup_fee_name: null,
              setup_fee_tax_rate_id: null,
              total_unit_count: null,
              total_units_count: null,
              available_units_count: 0,
              updated_at: null,
              width: 0,
              units: filteredUnitsFromList,
              size: size,
              plans: [],
            });
          }
        } else {
          unitType.units = units.value.filter(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            (item: UnitInterface) => item.unit_group_id == unitType.id
          );
          newUnitTypes.value.push(unitType);
        }
      } else {
        unitType.units = units.value.filter(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          (item: UnitInterface) => item.unit_group_id == unitType.id
        );
        if (unitType.units.length > 0 && api_settings.sort_units) {
          if (unitType.units[0]) {
            unitType.units = unitType.units.filter(
              (item: UnitInterface) =>
                item.width == unitType.width &&
                item.length == unitType.length &&
                item.exclude_from_website == false
            );
          }
        }
      }
      if (api_settings.sort_units_by_size) {
        unitTypes.value = uniqueBy(
          newUnitTypes.value,
          (unitType: UnitTypeInterface) =>
            [unitType.id, unitType.size, unitType.description].join("-")
        );
      }
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getLedgers() {
  errors.value = "";
  const response = await api({
    url: `ledgers/?facilityId=${props.facilityId}&per_page=1000`,
  });
  if (response.status == 200) {
    // StorEdge wraps the list in `ledgers`; providers that answer with a plain
    // array (CC Storage) were silently leaving the grid with no ledgers at all,
    // so no unit could ever be coloured delinquent or moving out.
    if (response.body.ledgers) {
      ledgers.value = response.body.ledgers;
    } else if (Array.isArray(response.body)) {
      ledgers.value = response.body;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUnits() {
  if (api_settings.units_with_customer_list) {
    await getCustomers();
  }
  if (api_settings.ledgers_on_units_grid) {
    await getLedgers();
  }

  errors.value = "";
  let response = null;
  if (api_settings.paging_units) {
    response = await api({
      url: `units/?facilityId=${props.facilityId}&include=meta&include_tenant=${api_settings.units_with_customer_list}`,
    });
  }

  if ((response && response.status == 200) || !api_settings.paging_units) {
    let pagination = "";
    if (
      response &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      response.body.meta &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      response.body.meta.pagination.total_entries
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      pagination = response.body.meta.pagination.total_entries;
    }

    const responseData = await api({
      url: `units/?facilityId=${props.facilityId}&per_page=${pagination}&include_tenant=${api_settings.units_with_customer_list}`,
    });

    if (responseData.status == 200) {
      if (responseData.body.units) {
        units.value = uniqueBy(
          responseData.body.units,
          (unit: UnitInterface) => unit.id
        );
      } else {
        units.value = uniqueBy(
          responseData.body,
          (unit: UnitInterface) => unit.id
        );
      }
      for (let unit of units.value) {
        unit.customer = null;
        let rented = false;
        if (unit.current_ledger_id) {
          unit.ledger_status = ledgers.value.filter(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            (ledger: { id: number }) => ledger.id == unit.current_ledger_id
          )[0];
          if (unit.ledger_status) {
            if (unit.ledger_status.auction_id) {
              unit.status = "auction";
            } else if (unit.ledger_status.scheduled_move_out) {
              unit.status = "moving_out";
            } else if (unit.ledger_status.delinquent) {
              unit.status = "delinquent";
            }
          }
        }
        if (
          api_settings.units_with_customer_list &&
          unit.status != "available"
        ) {
          let customer = customers.value.filter(
            (item: CustomerDataInterface) => item.id == unit.current_tenant_id
          )[0];
          unit.customer = customer;
        }
        if (
          unit.status &&
          ["leased", "rented", "occupied"].includes(unit.status.toLowerCase())
        ) {
          rented = true;
        }
        if (!unit.rentable && !rented && !isUnrentableStatus(unit.status)) {
          // A status that already says why the unit can't be rented keeps its
          // own label and colour; the blanket fallback used to flatten
          // locked-out and auction units into a grey "Unavailable".
          unit.status = "unavailable";
        }
      }

      getAllUnitGroups();
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
    status.value = "loaded";
  }
}
getUnits();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("fieldset", null, [
      (status.value === 'loading')
        ? (_openBlock(), _createBlock(BaseSpinner, {
            key: 0,
            preset: "large"
          }))
        : _createCommentVNode("", true),
      (units.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitTypes.value, (unitType) => {
              return (_openBlock(), _createElementBlock("div", {
                key: unitType.id + 'unitType'
              }, [
                _createElementVNode("div", null, [
                  (unitType.size)
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(unitType.size), 1))
                    : (unitType.units.length)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(unitType.units[0].size), 1))
                      : _createCommentVNode("", true),
                  (unitType.description)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(unitType.description), 1))
                    : _createCommentVNode("", true)
                ]),
                (unitType.units.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitType.units, (unit) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: unit.id + 'unitTypeUnit',
                          onMouseover: ($event: any) => (hoverUnit(unit.id)),
                          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoverUnit('-1')))
                        }, [
                          (unit.status)
                            ? (_openBlock(), _createBlock(_component_RouterLink, {
                                key: 0,
                                to: {
                name: 'unit_detail_storedge',
                params: { id: unit.id, facilityId: __props.facilityId },
              },
                                class: _normalizeClass(["box", unit.status.toLowerCase()])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(unit.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to", "class"]))
                            : _createCommentVNode("", true),
                          (hover.value == unit.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("b", null, _toDisplayString(unit.name) + " - " + _toDisplayString(unit.size), 1)
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _hoisted_11,
                                  _createElementVNode("p", null, "Status: " + _toDisplayString(unit.status), 1),
                                  (unit.status && unit.status.toLowerCase() == 'available')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Price: " + _toDisplayString(unit.price) + " Each Month ", 1))
                                    : _createCommentVNode("", true),
                                  (unit.customer)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _hoisted_14,
                                        _createElementVNode("p", null, " Name: " + _toDisplayString(unit.customer.first_name) + " " + _toDisplayString(unit.customer.last_name), 1),
                                        _hoisted_15,
                                        (unit.customer.formatted_phone)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(unit.customer.formatted_phone), 1))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unit.customer.phone_numbers, (phone) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: phone.id + 'phone'
                                          }, [
                                            _createElementVNode("p", null, _toDisplayString(phone.formatted_number) + " - " + _toDisplayString(phone.label), 1),
                                            _hoisted_17
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 40, _hoisted_7))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, "No units for this unit type"))
              ]))
            }), 128)),
            _hoisted_19
          ]))
        : _createCommentVNode("", true)
    ]),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(errors.value), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})